import React, { Component } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'
import './Header.scss'

class HeaderProject extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            visible: false,
        }

        this.showMenu = this.showMenu.bind(this)
        this.hideMenu = this.hideMenu.bind(this)
    }

    showMenu() {
        this.setState({
            visible: true,
        })
    }

    hideMenu() {
        this.setState({
            visible: false,
        })
    }

    render() {
        const appName = this.props.cookies.get('app_name')
        let topLogo = require('../../../Res/img/top_logo.png')
        if (appName && appName !== '') {
            topLogo = require(`../../../Res/3rd/${appName}/img/top_logo.png`)
        }

        return (
            <div>
                <div className="header_wrap">
                    <div className="bottom_wrap">
                        <div className="common_wrap">
                            <div className="logo">
                                <Link to="/">
                                    <img src={topLogo} alt="HausPlanner" width="166" />
                                </Link>
                            </div>
                            <div className="navi">
                                <div>
                                    <div className="nav_project_no pc_v">
                                        {/* <Link to="/plan">설계</Link>
                    <div className="line" /> */}
                                        {/* <Link to="/magazine">매거진</Link>
                    <div className="line" /> */}
                                        {/* <Link to="/bidding">견적요청</Link>
                    <div className="line" /> */}
                                        <Link to="/project">프로젝트 목록</Link>
                                        {this.props.cookies.get('demo') === 'false' && <div className="line" />}
                                        {this.props.cookies.get('demo') === 'false' && (
                                            <Link to="/mypage">마이페이지</Link>
                                        )}
                                        {/* <Link to="/seminar"><div className="seminar_btn">교육</div></Link> */}
                                    </div>
                                </div>
                            </div>
                            <div className="menu_btn mobile_v" onClick={() => this.showMenu()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17">
                                    <path
                                        fill="#000"
                                        fillRule="nonzero"
                                        d="M0 8.309c0-.669.542-1.21 1.21-1.21h13.58a1.21 1.21 0 0 1 0 2.42H1.21A1.21 1.21 0 0 1 0 8.309zm0 7.098c0-.668.542-1.21 1.21-1.21h19.58a1.21 1.21 0 1 1 0 2.42H1.21A1.21 1.21 0 0 1 0 15.407zM0 1.21C0 .542.542 0 1.21 0h19.58a1.21 1.21 0 0 1 0 2.42H1.21A1.21 1.21 0 0 1 0 1.21z"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* mobile menu */}
                        <div
                            className={this.state.visible ? 'menu_show mobile_menu_bg' : 'menu_hide mobile_menu_bg'}
                            onClick={() => this.hideMenu()}>
                            <div className="mobile_menu_wrap">
                                <div className="close_btn" onClick={() => this.hideMenu()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#ECEEF3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2.4">
                                            <path d="M18 2L2 18M2 2l16 16" />
                                        </g>
                                    </svg>
                                </div>
                                {this.props.cookies.get('demo') === 'false' && (
                                    <div className="top">
                                        <Link to="/mypage">
                                            <div className="top_btn">
                                                MY
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    width="8"
                                                    height="12"
                                                    viewBox="0 0 8 12">
                                                    <defs>
                                                        <path id="arrow1" d="M112 0h208v568H112z" />
                                                        <filter
                                                            id="arrow2"
                                                            width="106.7%"
                                                            height="102.5%"
                                                            x="-4.3%"
                                                            y="-1.2%"
                                                            filterUnits="objectBoundingBox">
                                                            <feOffset
                                                                dx="-2"
                                                                in="SourceAlpha"
                                                                result="shadowOffsetOuter1"
                                                            />
                                                            <feGaussianBlur
                                                                in="shadowOffsetOuter1"
                                                                result="shadowBlurOuter1"
                                                                stdDeviation="2"
                                                            />
                                                            <feColorMatrix
                                                                in="shadowBlurOuter1"
                                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                                                            />
                                                        </filter>
                                                    </defs>
                                                    <g fill="none" fillRule="evenodd">
                                                        <path fill="#000" fillOpacity=".6" d="M-198-24h320v618h-320z" />
                                                        <g transform="translate(-198 -24)">
                                                            <use
                                                                fill="#000"
                                                                filter="url(#arrow2)"
                                                                xlinkHref="#arrow1"
                                                            />
                                                            <use fill="#FFF" xlinkHref="#arrow1" />
                                                        </g>
                                                        <path
                                                            stroke="#24524A"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth="1.2"
                                                            d="M1.5 1.5l5 4.5-5 4.5"
                                                        />
                                                    </g>
                                                </svg>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                                <div className="top_no_project">
                                    <Link to="/project">
                                        <div className="project_add_wrap">
                                            <div className="plus_border">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13">
                                                    <g
                                                        fill="none"
                                                        fillRule="evenodd"
                                                        stroke="#000"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.3">
                                                        <path d="M6 1.5v10.7M11.35 6.85H.65" />
                                                    </g>
                                                </svg>
                                            </div>
                                            <p>프로젝트 선택</p>
                                        </div>
                                    </Link>
                                </div>

                                <ul className="top_menu">
                                    {/* <li><Link to="/seminar/">세미나신청</Link></li>
                  <li><Link to="/magazine/">매거진</Link></li> */}
                                    {/* <li><Link to="/bidding/">견적요청</Link></li> */}
                                </ul>

                                <div className="bottom">
                                    <div className="footer_menu">
                                        {/* <a href="http://www.ai-con.co.kr" target="_blank" rel="noreferrer">
                                            회사소개
                                        </a>
                                        <a href="http://cafe.naver.com/usehands" target="_blank" rel="noreferrer">
                                            네이버 카페
                                        </a> */}
                                        <Link to="/policy/">이용약관</Link>
                                        <Link to="/policy/">개인정보처리방침</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(HeaderProject)



// WEBPACK FOOTER //
// ./Src/Components/Commons/HeaderProject.js